import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { bookingInfo } from '../../booking/book.helper';


@Component({
  selector: 'app-step5',
  templateUrl: './step5.component.html',
})
export class Step5Component implements OnInit{
  @Input('updateParentModel') updateParentModel!: (
    part: Partial<bookingInfo>,
    isFormValid: boolean
  ) => void;
  form!: FormGroup;
  @Input() defaultValues!: Partial<bookingInfo>;

  private unsubscribe: Subscription[] = [];

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {

  }

}
